import React from 'react';
import { useLocation } from 'react-router-dom';
import { useInquiry } from '../../context/InquiryContext';
import './InquiryButton.css';

const InquiryButton = () => {
  const { getInquiryCount, toggleInquiry, isInquiryOpen } = useInquiry();
  const location = useLocation();
  const count = getInquiryCount();

  // Don't show the floating button if sidebar is open, no items, or on messages page
  const isMessagesPage = location.pathname === '/messages' || location.pathname === '/message';
  if (isInquiryOpen || count === 0 || isMessagesPage) return null;

  return (
    <button className="floating-inquiry-button" onClick={toggleInquiry}>
      <div className="inquiry-icon-wrapper">
        <svg width="28" height="28" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M3 3H5L5.4 5M7 13H17L21 5H5.4M7 13L5.4 5M7 13L4.707 15.293C4.077 15.923 4.523 17 5.414 17H17M17 17C15.895 17 15 17.895 15 19C15 20.105 15.895 21 17 21C18.105 21 19 20.105 19 19C19 17.895 18.105 17 17 17ZM9 19C9 20.105 8.105 21 7 21C5.895 21 5 20.105 5 19C5 17.895 5.895 17 7 17C8.105 17 9 17.895 9 19Z" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
        <span className="inquiry-count">{count}</span>
      </div>
      <span className="inquiry-label">View Inquiry</span>
    </button>
  );
};

export default InquiryButton;
